// A saved-filter row, expressed as a render function rather than a template.
//
// Vuetify components are imported explicitly and handed to `h()` as component
// objects. That is deliberate: @nuxtjs/vuetify tree-shakes via vuetify-loader,
// which only auto-registers the Vuetify components it can see *in templates*.
// Components referenced from a render function are invisible to that scan, so
// in a tree-shaken build string tags like "v-icon" resolve to nothing and
// render as raw <v-icon> elements -- leaking their icon-name text children
// (mdi-pencil, mdi-delete, ...) straight into the visible label. Importing the
// components sidesteps registration entirely.
import { VBtn } from "vuetify/lib/components/VBtn";
import { VIcon } from "vuetify/lib/components/VIcon";
import {
  VListItem,
  VListItemAction,
  VListItemTitle,
} from "vuetify/lib/components/VList";

export const FilterSetItem = {
  props: {
    set: {
      type: Object,
      required: true,
    },
    hasCurrentState: {
      type: Boolean,
      required: true,
    },
  },
  render(h) {
    const actions = this.set.can_edit
      ? h(
          VListItemAction,
          {
            staticClass: "flex-row",
          },
          [
            h(
              VBtn,
              {
                attrs: {
                  icon: true,
                  small: true,
                  disabled: !this.hasCurrentState,
                  title: "Overwrite with current filters",
                },
                on: {
                  click: (event) => {
                    event.stopPropagation();
                    this.$emit("overwrite", this.set);
                  },
                },
              },
              [h(VIcon, { attrs: { small: true } }, "mdi-content-save-edit")]
            ),
            h(
              VBtn,
              {
                attrs: {
                  icon: true,
                  small: true,
                  title: "Rename",
                },
                on: {
                  click: (event) => {
                    event.stopPropagation();
                    this.$emit("rename", this.set);
                  },
                },
              },
              [h(VIcon, { attrs: { small: true } }, "mdi-pencil")]
            ),
            h(
              VBtn,
              {
                attrs: {
                  icon: true,
                  small: true,
                  title: "Delete",
                  "data-test": `filter-set-delete--${this.set.id}`,
                },
                on: {
                  click: (event) => {
                    event.stopPropagation();
                    this.$emit("delete", this.set);
                  },
                },
              },
              [h(VIcon, { attrs: { small: true } }, "mdi-delete")]
            ),
          ]
        )
      : null;

    return h(
      VListItem,
      {
        attrs: {
          "data-test": `filter-set-item--${this.set.id}`,
        },
        on: {
          click: () => this.$emit("load", this.set),
        },
      },
      [h(VListItemTitle, this.set.name), actions]
    );
  },
};
